function determineWhereToRedirectUserWhenLoggedIn(actuatedElement) {
    if (actuatedElement.tagName === 'A' && actuatedElement.href && actuatedElement.href.length > 0) {
        return actuatedElement.href;
    }
    if (actuatedElement.tagName === 'FORM' && actuatedElement.action && actuatedElement.method === 'get') {
        const formData = new FormData(actuatedElement);
        const searchString = new URLSearchParams(formData).toString();
        return actuatedElement.action + '?' + searchString;
    }
    const hashToUse = actuatedElement.id ? `#${actuatedElement.id}` : window.location.hash;

    const queryParams = new URLSearchParams(window.location.search);
    const action = actuatedElement.getAttribute('data-redirection-action');
    const searchProfileId = actuatedElement.getAttribute('data-profileid');
    const searchProfileFirstName = actuatedElement.getAttribute('data-profilefirstname');

    if (action) {
        queryParams.set('action', action);
        queryParams.set('id', searchProfileId);
        queryParams.set('name', searchProfileFirstName);
    }

    return window.location.pathname + `?${queryParams.toString()}` + hashToUse;
}

function shouldUseSignupPageInsteadOfPopup(actuatedElement) {
    return (
        // the data attributes allow for selectively enable the feature on specific pages at first
        actuatedElement.hasAttribute('data-ff4j-signup-entrypoint-redirection') ||
        document.body.hasAttribute('data-ff4j-signup-entrypoint-redirection') ||
        // at one point we will enable the feature more globally
        (window.features && window.features.replaceSignupPopupWithSignupPage)
    );
}

/**
 * Determine the URL where to redirect the user for a full-page signup experience.
 *
 * <p>
 * The URL includes a `redirect` parameter to send the user either back to the current page or to
 * the link they clicked on.
 * </p>
 *
 * @param actuatedElement {HTMLElement} the HTML element the user actuated (A, BUTTON, FORM...)
 * @returns {string|null} the signup URL to use if the feature is enabled, `null` otherwise
 */
export function determineSignupUrl(actuatedElement) {
    if (!shouldUseSignupPageInsteadOfPopup(actuatedElement)) {
        return null;
    }

    const redirectParam = determineWhereToRedirectUserWhenLoggedIn(actuatedElement);

    // I left is as I found it, but I think it would be wise to:
    //   - check for a more precise pattern, such as /^\/proposal\/.*/
    //   - or even better not check for patterns at all but annotate the page(s) concerned so that
    //     we don't need to change this shared script.
    const isUrlFromProposal = window.location.pathname.includes('proposal');

    return isUrlFromProposal
        ? // please keep the trailing slash below because of https://github.com/nuxt/nuxt/issues/21872
          `/signup-client/?redirect=${encodeURIComponent(redirectParam)}`
        : `/who-are-you?redirect=${encodeURIComponent(redirectParam)}`;
}

/**
 * Determine the URL where to redirect the user for a full-page signin experience.
 *
 * <p>
 * The URL includes a `redirect` parameter to send the user either back to the current page or to
 * the link they clicked on.
 * </p>
 *
 * @param actuatedElement {HTMLElement} the HTML element the user actuated (A, BUTTON, FORM...)
 * @returns {string|null} the signin URL to use if the feature is enabled, `null` otherwise
 */
export function determineSigninUrl(actuatedElement) {
    if (!window.features || !window.features.replaceSigninPopupWithSigninPage) {
        return null;
    }

    const redirectParam = determineWhereToRedirectUserWhenLoggedIn(actuatedElement);

    return `/signin?redirect=${encodeURIComponent(redirectParam)}`;
}
